import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { passengerCMSApi } from "~/Services";

interface DocumentDetailsResponse {
  id: number;
  name: string;
  description: string;
  airports_en: string;
  airports_ms: string;
  airports_zh: string;
  key_english: string;
  key_malay: string;
  key_mandarin: string;
  image_url: string;
  redirect_english: string;
  redirect_malay: string;
  redirect_mandarin: string;
  name_malay: string;
  name_mandarin: string;
  published: boolean;
}

// edit api call
const fetchMainHeaderDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await passengerCMSApi.get(`/api/get-main-menu-list-crud-api-data/${id}`);
  return response.data.data;
};

const useMainHeaderDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["subCategoriesDocumentDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchMainHeaderDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useMainHeaderDocumentDetails };
